<template>
  <div class="game">
    <div class="gameback">
      <img :src="gameBanner" />
    </div>
    <!-- 支付id -->
    <div class="title">
      <span class="test">{{ $t('game.useTitle') }}</span>
      <p v-if="loginsty==2" class="findid"  @click="qusetionis = true">
         <span class="circle">?</span>{{$t('game.findid')}}
      </p>
    </div>
    <div style="clear: both;"></div>
    <div v-if="editis == false">
      <div v-if="loginsty==2">
        <div class="print">
          <input :class="{'gray-input':checkis}" type="text" v-model="gameinfo.id" :disabled="checkis" />
          <span @click="checkid('leftcount')" v-show="!checkis">{{ $t('game.checkBtn') }}</span>
          <span v-show="checkis" class="loadbtn"> <img class="btnload" src="static/images/btnload.png" /></span>
        </div>
        <div class="info" v-if="checktext==''">{{ $t('game.checktext') }}</div>
        <div class="info redcolor" v-else>{{checktext}}</div>
      </div>
      <div v-else-if="loginsty==1">
        <div @click="openlogin" class="applogin_loginbtn loginsty1">{{ $t('game.login') }}</div>
      </div>
    </div>
    <div class="userinfo" v-else-if="editis == true">
      <img :src="gameinfo.icon" />
      <div class="username" v-if="!(gameinfo.extra_info && gameinfo.extra_info.key && gameinfo.extra_info.value!='')">
        <p><span>{{ $t('game.username') }}</span>{{gameinfo.name}}</p>
        <p><span>{{ $t('game.userId') }}</span>{{gameinfo.role_id}}</p>
      </div>
      <div class="username userthree" v-else>
        <p><span>{{ $t('game.username') }}</span>{{gameinfo.name}}</p>
        <p><span>{{ $t('game.userId') }}</span>{{gameinfo.role_id}}</p>
        <p><span>{{gameinfo.extra_info.key}}：</span>{{gameinfo.extra_info.value}}</p>
      </div>
      <span class="edit" @click="logout()">
        <img src="static/images/logout.png"/>
      </span>
    </div>
    <div style="clear: both;"></div>

    <div
      v-if="gameid === '20042'"
      class="nopackage"
      style="line-height: 1.5; display: flex; align-items: center; justify-content: center"
    >
      <a style="color: rgba(60, 228, 134, 1)" href="https://store.centurygames.com/da"
        >VIP Mall is now closed, but you're invited to check out our official store, Webshop.</a
      >
    </div>
    <template v-if="showPackageList">
      <!-- 礼包列表 -->
      <div class="title">
        {{ $t('game.packageTitle') }}
      </div>
      <div class="payitem gamepayitem">
        <template v-for="(item,index) in list">
          <!-- diy -->
          <div class="listitem diylist" :keys="index"
            v-if="showid(item.id) && item.package_type && item.package_type==2" @click="selpackage(item)">
            <div class="diycontent">
              <div class="paytag" v-if="disabledval!='' && item.tag!='' && item.tag+''!='undefined'">
                <img :src="'/static/images/tag/tag'+item.tag+'.png'" />
                <span class="tagtotal" v-if="checkList.indexOf('total')>-1">
                  {{ item.package.value_comba +' x' }}
                </span>
                <span class="tagtotal numtag" v-if="checkList.indexOf('bonus')>-1">
                  {{ '+' + item.package.give_away_number  }}
                </span>
                <span class="tagtotal bonusoff" v-if="checkList.indexOf('bonusoff')>-1">
                  <span> {{ item.package.give_away_rate +'%' }}</span>
                  <span class="bonus">{{gameid=='20073'?'More':'BONUS'}}</span>
                </span>
                <span class="tagtotal bonusoff " v-if="checkList.indexOf('off')>-1">
                  <span> {{ item.package.discount +'%' }}</span>
                  <span>OFF</span>
                </span>
              </div>
              <p class="diyimg"><img v-if="checkList.indexOf('packpic')>-1" :src="item.package.package_pic" /></p>
              <div
                :class="{'diymian':true,'diynomain':checkList.indexOf('item')==-1 || difpackageinfo['vip'+item.id].other_content.length<=0 }"
                v-if="checkList.indexOf('mainitems')>-1 && difpackageinfo['vip'+item.id] && difpackageinfo['vip'+item.id].main_content"
                @click="openother(item.package.diy_main_content,difpackageinfo['vip'+item.id].main_content,'main',item.id)">
                <img v-if="item.package.diy_main_content.length>1" class="diychange" src="static/images/change.png" />
                <img class="diymain_content" :src="difpackageinfo['vip'+item.id].main_content.pic_url
" />
                <p class="diynumber">
                  <span class="diymainorigin"
                    v-if="checkList.indexOf('mainorigin')>-1">{{setcount(difpackageinfo['vip'+item.id].main_content.main_content_original_number)}}</span>
                  <span>{{setcount(difpackageinfo['vip'+item.id].main_content.main_number)}}</span>
                </p>
              </div>
              <div v-if="checkList.indexOf('item')>-1 &&  difpackageinfo['vip'+item.id].other_content.length>0"
                :class="{'diyother':true,'diyothernomain':checkList.indexOf('mainitems')==-1 || !difpackageinfo['vip'+item.id].main_content}">
                <p v-for="(l,i) in difpackageinfo['vip'+item.id].other_content"
                  @click="openother(item.package.diy_other_content['分组'+(i+1)],l,'other',item.id,i)"
                  :class="getotherClass(difpackageinfo['vip'+item.id].other_content)" :keys="i">
                  <img class="diychange"
                    v-if="item.package.diy_other_content['分组'+(i+1)].length && item.package.diy_other_content['分组'+(i+1)].length>1"
                    src="static/images/change.png" />
                  <img :src="l.pic_url" />
                  <span>{{ ' X' + setcount(l.count)}}</span>
                </p>
              </div>
            </div>
            <div :class="{'diybottom':true,'diybottomcenter':checkList.indexOf('packname')==-1}">
              <p class="diyname" v-if="checkList.indexOf('packname')>-1">
                {{item.package.package_en_name}}
              </p>
              <p class="payitembtn" v-if="checkList.indexOf('price')>-1">
                <span class="paybtnpast"
                  v-if="checkList.indexOf('originprice')>-1">{{moneyunit+ priceinit(item.package.external_amount)}}</span>
                <span
                  :class="{'paybtnnow':true,'diypaybtnnowonly':checkList.indexOf('originprice') <= -1}">{{ moneyunit + item.package.final_amount}}</span>
              </p>
            </div>

            <img v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'" class="imgleft"
              src="static/images/lefticon.png" />
            <div v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'"
              class="leftnum">LEFT {{item.package.limit_pay_count}}</div>

            <div class="soldout" @click.stop="soldout"
              v-if="(item.package.limit_pay_count*1 == 0 && (item.package.limit_pay_count+'') != 'null')">
              <img src="static/images/out.png" />
            </div>

            <div class="selnow" v-show="packageid == item.id">
              <img src="static/images/choose.png" />
            </div>
          </div>

          <!-- normal -->
          <div class="listitem" :keys="index" v-else-if="showid(item.id) " @click="selpackage(item)">
            <div class="selnow" v-show="packageid == item.id">
              <img src="static/images/choose.png" />
            </div>
            <div class="soldout" @click.stop="soldout"
              v-if="(item.package.limit_pay_count*1 == 0 && (item.package.limit_pay_count+'') != 'null')">
              <img src="static/images/out.png" />
            </div>
            <img v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'" class="imgleft"
              src="static/images/lefticon.png" />
            <div v-if="item.package.limit_pay_count != 0 && (item.package.limit_pay_count+'') != 'null'"
              class="leftnum">LEFT {{item.package.limit_pay_count}}</div>
            <p class="paytitle" v-if="checkList.indexOf('packname')>-1">{{item.package.package_en_name}}</p>
            <div class="packageimg">
              <img class="payall" v-if="checkList.indexOf('packpic')>-1" :src="item.package.package_pic" />
              <p class="paytag" v-if="disabledval!='' && item.tag!='' && item.tag+''!='undefined'">
                <img :src="'/static/images/tag/tag'+item.tag+'.png'" />
                <span class="tagtotal" v-if="checkList.indexOf('total')>-1">
                  {{ item.package.value_comba +' x' }}
                </span>
                <span class="tagtotal numtag" v-if="checkList.indexOf('bonus')>-1">
                  {{ '+' + item.package.give_away_number  }}
                </span>
                <span class="tagtotal bonusoff" v-if="checkList.indexOf('bonusoff')>-1">
                  <span> {{ item.package.give_away_rate +'%' }}</span>
                  <span class="bonus">{{gameid=='20073'?'More':'BONUS'}}</span>
                </span>
                <span class="tagtotal bonusoff " v-if="checkList.indexOf('off')>-1">
                  <span> {{ item.package.discount +'%' }}</span>
                  <span>OFF</span>
                </span>
              </p>
            </div>
            <div class="maincontent" v-if="checkList.indexOf('mainitems')>-1">
              <p class="original_number" v-if="checkList.indexOf('mainorigin')>-1">
                <span
                  v-if="item.package.main_content_original_number >0 ">{{setcount(item.package.main_content_original_number)}}</span>
                <span v-else></span>
              </p>
              <p class="itemlistitem">
                <img :src="item.package.main_content" />
                <span>{{setcount(item.package.main_number)}}</span>
              </p>

            </div>
            <div class="itemlist" v-if="checkList.indexOf('item')>-1">
              <p v-for="(l,i) in item.package.other_content"
                :class="{'itemlistitem':true,'nowarpitem':item.package.other_content.length==3}" :keys="i">
                <img :src="l.content" />
                <span>{{setcount(l.count)}}</span>
              </p>
            </div>
            <p class="payitembtn" v-if="checkList.indexOf('price')>-1">
              <span v-if="checkList.indexOf('originprice')>-1"
                class="paybtnpast">{{moneyunit+ priceinit(item.package.external_amount)}}</span>
              <span
                :class="{'paybtnnow':true,'paybtnnowonly':checkList.indexOf('originprice') <= -1}">{{ moneyunit + item.package.final_amount}}</span>
            </p>
          </div>

        </template>
        <div class="nopackage" v-if="list.length === 0">
          <p v-if="nopackis"> Game gift pack update in progress</p>
          <p v-else><img class="load" src="static/images/load.gif" /></p>
        </div>
        <div class="nopackage" v-if="shownopackage()">
          <p> Game gift pack update in progress</p>
        </div>

      </div>
      <!-- 支付选择 -->
      <div class="title">
        {{ $t('game.paymentTitle') }}
      </div>
      <div class="payimgflex">
        <div v-for="(item, index) in payway" :key="index" :class="{'payimg':true,'payimgall': payway.length === 1}"
          @click="paychange(item)">
          <img :src="`static/images/${item}.png`" />
          <img class="paychose" src="static/images/choose.png" v-if="paysty == item" />
        </div>
      </div>
      <div class="pay payfly">
        <div class="userid">
          {{ $t('game.userId') }}
          <span v-if="gameinfo.role_id!=''">{{gameinfo.role_id+'(' +gameinfo.name +')'}}</span>
          <span class="redcolor" v-if="checktext!=''">{{checktext}}</span>
        </div>
        <div class="money">
          <p>{{ $t('game.total') }}: <span>{{ moneyunit + gameinfo.money}}</span></p>
          <p class="moneyexplain">
            <template v-if="isGlobal">
              <b v-if="pakcageis">Price includes taxes</b>
              <b class="redcolor" v-else>{{ $t('game.noSelectPackageTips') }}</b>
            </template>
            <template v-else>
              <b class="redcolor" v-if="!packageid">{{ $t('game.noSelectPackageTips') }}</b>
            </template>
          </p>
        </div>
        <div @click="gotodetail" class="paybtn">{{ $t('game.goPay') }}</div>
      </div>
    </template>
    <img class="apology_pic" v-if="showApologyPic" :src="apology_pic" />

    <!-- 支付结果 -->
    <div class="mask" v-if="maskstyle != ''">
      <div class="alert">
        <img class="close" @click="maskstyle = ''" src="static/images/close.png" />
        <div class="alertmain">

          <div class="alerthead">
            <img v-show="maskstyle == 'success'" src="static/images/success.png" />
            <img v-show="maskstyle !== 'success'" src="static/images/fail.png" />
            <p v-if="maskstyle == 'payfail'">
              <span class="alertinfo">
                {{ $t('game.payFail') }}
              </span>
              <span>{{ $t('game.payFailTips1') }} {{ paysty=='paypal'?"Paypal":"Adyen" }}
                {{ $t('game.payFailTips2') }}</span>
            </p>
            <p v-else-if="maskstyle == 'deliveryfail'">
              <span class="alertinfo">
                {{ $t('game.deliveryFail') }}
              </span>
              <span>{{ $t('game.deliveryFailTips') }}</span>
            </p>
            <p v-else-if="maskstyle == 'success'">
              <span class="alertinfo">
                {{ $t('game.paySuccess') }}
              </span>
              <span>{{ $t('game.paySuccessTips') }}</span>
            </p>
            <p v-else>
              <span class="alertinfo">
                {{ $t('game.payFail') }}
              </span>
              <!-- <span>Please wait a moment for delivery</span> -->
            </p>
          </div>

          <div class="alertcontent">
            <div v-if="maskstyle == 'success'" class="tip">
              {{ $t('game.paySuccessTips2') }}
            </div>
            <p class="alerttitle">{{ $t('game.orderTitle') }}</p>
            <p>
              <span>{{ $t('game.paidWith') }}</span>
              <span>{{paysty}}</span>
            </p>
            <p v-if="orderinfo.OrderID!=''">
              <span>{{ $t('game.orderID') }}</span>
              <span>{{orderinfo.OrderID}}</span>
            </p>
            <p v-if="orderinfo.TransactionID!=''">
              <span>{{ $t('game.transactionId') }}</span>
              <span>{{orderinfo.TransactionID}}</span>
            </p>
            <p>
              <span>{{ $t('game.payStatus') }}</span>
              <span v-if="maskstyle == 'payfail'" style="color: orangered;">{{ $t('game.camelPayfail') }}</span>
              <span v-else-if="maskstyle == 'deliveryfail'"
                style="color: orangered;">{{ $t('game.camelDeliveryFail') }}</span>
              <span v-else-if="maskstyle == 'success'" style="color: #3BE487;">{{ $t('game.camelPaySuccess') }}</span>
              <span v-else style="color: #orangered;">{{maskstyle}}</span>
            </p>
            <p>
              <span>{{ $t('game.orderTotal') }}</span>
              <span>{{moneyunit + orderinfo.real_amount}}</span>
            </p>
            <p v-if="orderinfo.Transactiondate!=''">
              <span>{{ $t('game.transactionDate') }}</span>
              <span>{{orderinfo.Transactiondate}}</span>
            </p>
          </div>

          <div class="alertbtn">
            <p class="big" @click="maskstyle = ''">{{ $t('game.goOnPay') }}</p>
            <p class="small" v-if="maskstyle == 'success' || maskstyle == 'deliveryfail'" @click="getinvoice">
              {{ $t('game.getInvoice') }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 确认订单 -->
    <div class="mask" v-if="orderconfirm">
      <div class="alert">
        <img class="close" @click="orderconfirm = false" src="static/images/close.png" />
        <div class="alertmain">
          <div class="alerthead" style="height: 1.875rem;">
            <p><span class="alertinfo">{{ $t('game.confirmOrder') }}</span></p>
          </div>

          <div class="alertcontent">
            <p class="alerttitle">{{ $t('game.confirmFollow') }}</p>
            <p>
              <span>{{ $t('game.nickname') }}</span>
              <span>{{gameinfo.name+"("+gameinfo.id+")"}}</span>
            </p>
            <p>
              <span>{{ $t('game.packageName') }}</span>
              <span>{{gameinfo.packagename}}</span>
            </p>
            <p>
              <span>{{ $t('game.confirmPayWith') }}</span>
              <span>{{paysty}}</span>
            </p>
            <p class="alerttotal">
              <span>{{ $t('game.totalPayment') }}</span>
              <span style="color: #3BE487;font-size: 1.125rem;">{{moneyunit + gameinfo.money}}</span>
            </p>
          </div>
          <div class="explain" v-if="paysty === 'adyen'">
            The payment service is provided by Adyen, which operates under a banking license and is supervised by the
            Dutch Central Bank. If you have any inquiries about its Certifications, please refer to <a
              href="https://www.adyen.com/platform/certifications">https://www.adyen.com/platform/certifications</a>. As
            for how they protect your data, please refer to <a
              href="https://www.adyen.com/policies-and-disclaimer/privacy-policy">https://www.adyen.com/policies-and-disclaimer/privacy-policy.</a>
          </div>
          <div class="explain" v-if="paysty === 'paypal'">
            The payment service is provided by PayPal. As for how they protect your data, please refer to <a
              href="https://www.paypal.com/c2/webapps/mpp/ua/privacy-full">https://www.paypal.com/c2/webapps/mpp/ua/privacy-full</a>
          </div>
          <div class="explain" v-if="paysty === '微信'">
            支付服务由微信支付提供。若您想了解微信支付的信息安全政策，请前往：<a
              href="https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy">https://weixin.qq.com/cgi-bin/readtemplate?lang=zh_CN&t=weixin_agreement&s=privacy</a>
          </div>
          <div class="explain" v-if="paysty === '支付宝'">
            支付服务由支付宝提供。若您想了解支付宝支付的信息安全政策，请前往：<a
              href="https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132">https://render.alipay.com/p/yuyan/180020010001196791/preview.html?agreementId=AG00000132</a>
          </div>
          <div class="alertbtn">
            <p class="big" @click="pay">{{ $t('game.confirmAndGoOn') }}</p>
            <p class="small" @click="orderconfirm = false">{{ $t('game.orderCancel') }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 获取凭据 -->
    <div class="mask" v-if="invoiceis">
      <div class="alert">
        <img class="close" @click="invoiceis = false" src="static/images/close.png" />
        <div class="alertmain">
          <div class="alerthead" style="height: 1.875rem;">
            <p><span class="alertinfo">{{ $t('game.getInvoiceTitle') }}</span></p>
          </div>
          <div class="alertcontent">
            <p class="alerttitle invoicetitle">{{ $t('game.getInvoiceTips') }}</p>
            <div class="email">
              <input type="text" :placeholder="$t('game.getInvoiceTips1')" v-model="mail_data.mail" />
            </div>
            <div class="checkbox">
              <label for="collection"> <input id="collection" name="collection" type="checkbox"
                  v-model="mail_data.is_remember" />{{ $t('game.getInvoiceTips2') }}</label>

              <label for="send"><input id="send" name="send" type="checkbox"
                  v-model="mail_data.is_send_information" />{{ $t('game.getInvoiceTips3') }}</label>
            </div>
          </div>

          <div class="alertbtn">
            <p class="big" @click="sendInvoice">{{ $t('game.invoiceSend') }}</p>
          </div>
        </div>
      </div>
    </div>
    <Foot :showParagraph="showPackageList"></Foot>
    <template v-if="shwoPayComponent">
      <div>
        <Ayden v-if="paysty === 'adyen'" :payinfo="payinfo" :mount="mount" :user_id="gameinfo.id"></Ayden>
        <Paypal
          v-if="paysty === 'paypal'"
          :payinfo="payinfo"
          :mount="mount"
          :paypal_client_id="paypal_client_id"
          :advanceCardSupport="advanceCardSupport"
          :is_paypal_advance="is_paypal_advance"
          />
        <Wechat v-if="paysty === '微信'" :payinfo="payinfo"></Wechat>
        <Alipay v-if="paysty === '支付宝'" :payinfo="payinfo"></Alipay>
      </div>
    </template>
    <Other v-if="otherselectis" :otherlist="otherlist" :nowselect="nowselect"></Other>
    <div class="mask apploginmask" v-if="apploginis">
        <div class="applogin" v-show="apploginsty == 1">
          <img @click="closeAppLoginModal" class="closegrey" src="static/images/closegrey.png" />
          <img class="applogin_logo" src="static/images/logo.png" />
          <div class="applogin_loginbtn applogin_loginbtn_fist" @click="jumpGame">
            <img src="static/images/gameicon.png" /> {{ $t('game.loginbtn') }}
          </div>
          <p class="applogin_text" @click="apploginsty=2">{{ $t('game.changebtn')}}</p>
        </div>

        <div class="applogin" v-show="apploginsty == 2">
          <img @click="closeAppLoginModal" class="closegrey" src="static/images/closegrey.png" />
          <img class="applogin_logo" src="static/images/logo.png" />

          <div class="title">
            <span class="test">{{ $t('game.loginuserid') }}</span><span class="circle" @click="qusetionis = true">?</span>
          </div>
          <div class="applogin_input">
            <!-- v-model="gameinfo.id" -->
            <input type="text" :class="{'gray-input':checkis}" v-model="gameinfo.id"  :disabled="checkis" :placeholder="$t('game.palceholder')" />
          </div>
          <div class="info redcolor">{{checktext}}</div>
          <div class="applogin_loginbtn applogin_input_btn" v-show="!checkis" @click="checkid('leftcount')">
          {{ $t('game.okbtn') }}
          </div>
          <div class="applogin_loginbtn applogin_input_btn loadbtn" v-show="checkis" >
              <img class="btnload" src="static/images/btnload.png" /> {{ $t('game.okbtn') }}
          </div>
          <div class="circlebtn" v-if="!appenv" @click="jumpGame">
            <img src="static/images/gameicon.png" />
          </div>
          <p class="applogin_text" v-else @click="jumpGame">{{ $t('game.inapptext')}}</p>
        </div>

    </div>

    <!-- userid引导框 -->
    <div class="mask qusetionis" v-show="qusetionis" @click.stop="qusetionis = false">
      <img class="close" @click="qusetionis = false" src="static/images/close.png" />
      <div class="qusetion">
        <div v-for="(item,index) in  quesarrr" :keys="index">
          <p>{{index*1+1+' '}}.</p>
          <img :src="item" />
        </div>
      </div>
    </div>

    <Notice ref="notice" :content="noticeinfo.content" :canceltext="noticeinfo.canceltext" :oktext="noticeinfo.oktext" :success="noticeinfo.success" :cancel="noticeinfo.cancel" :title="noticeinfo.title"></Notice>

  </div>
</template>

<script>
  import './game.css';
  import {
    gamePackagesInfo,
    gameInfo,
    checkfpid,
    getinvoice,
    adyen_payments_details,
    packagesinfo,
    upcustomurl,
    getSession,
    getUserInfoBySession
  } from '@/api/index.js'
  import PaymentLog from "../tool/payment.js"
  import Foot from '@/components/common/foot.vue'
  import Ayden from '@/components/common/ayden.vue'
  import Paypal from '@/components/common/paypal.vue'
  import Wechat from '@/components/common/wechat.vue'
  import Alipay from '@/components/common/alipay.vue'
  import Other from '@/components/common/otherselect.vue'
  import Notice from '@/components/common/notice.vue'
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import conutryarr from '@/components/common/country.js'
  export default {
    name: 'game',
    components: {
      Foot,
      Ayden,
      Paypal,
      Wechat,
      Alipay,
      Other,
      Notice
    },
    computed: {
      ...mapGetters([
        'conutry',
        'isGlobal'
      ]),
      // 展示礼包列表条件，游戏未开启白名单设置，或者开启白名单设置且当前用户在游戏白名单内
      showPackageList() {
        // DA 隐藏礼包列表
        if (this.gameid === '20042') return false
        return this.game_whitelist_status === 0 || (this.game_whitelist_status === 1 && this.player_whitelist_status &&
          this.gameinfo.role_id)
      },
      // 是否展示致歉图, 游戏开启白名单设置且当前用户不在游戏白名单内
      showApologyPic() {
        return this.game_whitelist_status === 1 && (!this.player_whitelist_status) && this.gameinfo.role_id
      }
    },
    watch: {
      conutry(newval, oldval) {
        //console.log('--------conutry-------')
        if (this.watchis) {
          if (newval.money && oldval.money && newval.money != oldval.money && this.gameid != '') {
            this.setShowLoading(true);

            if(this.editis){
              localStorage.setItem('vip_country_'+this.gameid+'_'+this.gameinfo.id,newval.content)
            }

            this.getPackageInfo(() => {
              this.packagereset(() => {
                this.setShowLoading(false);
                this.clearid();
              })
            })
          }
        } else {
          this.watchis = true;
        }

      }
    },
    data() {
      return {
        gameinfo: {
          id: '',
          icon: '',
          role_id: '',
          money: 0,
          name: '',
          packagename: '',
          extra_info: {}
        },
        // 游戏头图
        gameBanner: null,
        // 游戏是否开启白名单
        game_whitelist_status: 1,
        // 用户是否在游戏白名单内
        player_whitelist_status: false,
        // 开启白名单时，礼包列表为空，展示致歉图
        apology_pic: null,
        fpid: '',
        checktext: '',
        //钱符号
        moneyunit: '$ ',
        gameid: '',
        editis: false,
        checkList: [],
        list: [],
        nopackis: false,
        listid: '',
        disabledval: "",
        packageid: '',
        //分享人
        owner: '',
        //礼包字典
        packagedict: {

        },
        //控制弹框 payfail 支付失败, deliveryfail 充值失败,success 成功
        maskstyle: '',
        orderinfo: {
          OrderID: '',
          TransactionID: '',
          Transactiondate: '',
          real_amount: ''
        },
        // 确认订单弹窗
        orderconfirm: false,
        // 获取凭证弹窗
        invoiceis: false,
        //提示图片组
        qusetionis: false,
        quesarrr: [],
        //控制支付
        payinfo: {},
        mount: {},
        mail_data: {
          mail: "",
          is_remember: false,
          is_send_information: false
        },
        shortitem: false,
        //防止误触
        clickis: true,
        provider_order_id: '',
        redirectResult: '',
        pakcageis: true,
        // 当前支持的支付方式列表
        payway: [],
        // 当前选择支付方式
        paysty: null,
        // 是否显示对应的支付组件
        shwoPayComponent: false,
        // paypal高级卡支付是否支持当前币种，false为不支持当前币种或者游戏未开启高级卡支付
        advanceCardSupport: false,
        // 是否是新版paypal支付
        is_paypal_advance: false,
        paypal_client_id:'',
        //
        env: process.env.NODE_ENV,
        payment_log: null,
        payment_appid: '',
        gatewayMap: {
          '微信': 43,
          '支付宝': 14,
          paypal: 0,
          adyen: 75
        },
        gateway_package_ids: {},
        //用于追踪是否打开链接
        code: '',
        watchis: false,
        //游戏选择控制
        otherselectis: false,
        nowselect: {},
        otherselectsty: '',
        otherlist: [],
        //diy礼包配置
        difpackageinfo: {},
        //login方式
        apploginsty:1,
        apploginis:false,
        //login样式种类
        loginsty:3,
        noticeinfo:{
          content:'',
          success:null,
          cancel:0
        },
        //限制check 连点
        checkis:false,
        // 游戏登陆信息
        game_login_info: {},
        appenv:false,
        sessionclickis:false
      }
    },
    created() {
      //console.log(this.$route.query)
      this.gameid = this.getQueryString('game_id');
      if (this.getQueryString('list_id')) {
        this.list_id = this.getQueryString('list_id');
      }

      //判断是否在ajust 跳转异常的app中打开
      this.appenvtest();


      //获取用户的登录信息
      if (this.getQueryString('uid')) {
        //先取url的id
        this.gameinfo.id = this.getQueryString('uid');
      }else if(this.gameid){
        //没有的话查看本地是否有uid
        var uid =  localStorage.getItem("game_user_id_"+this.gameid);
        if(uid && uid!=''){
          this.gameinfo.id = uid;
        }
      }

      //获取国家
      if (this.getQueryString('country')) {
        conutryarr.forEach(item => {
          if (item.content == decodeURI(this.getQueryString('country'))) {
            this.$store.commit('SET_COUNTRY', item);
          }
        })
      } else {
        var localcountry = localStorage.getItem('vip_country_'+this.gameid+'_'+this.gameinfo.id);
        if(localcountry && localcountry!=''){
          //说明有国家缓存
        }else{
          //没有获取浏览器本地的
          localcountry = this.getfrontcountry();
        }

        //如果url没有国家取浏览器国家
        conutryarr.forEach(item => {
          if (item.content == localcountry) {
            this.$store.commit('SET_COUNTRY', item);
          }
        })
      }




      if (this.getQueryString('pack')) {
        this.packageid = this.getQueryString('pack');
      }
      if (this.getQueryString('owner')) {
        this.owner = this.getQueryString('owner');
      }

      if (this.getQueryString('provider_order_id')) {
        this.provider_order_id = this.getQueryString('provider_order_id');
      }


      if (this.getQueryString('gateway')) {
        const payWayMap = {
          43: '微信',
          14: '支付宝',
          0: 'paypal',
          75: 'adyen',
        }
        this.paysty = payWayMap[this.getQueryString('gateway')];
      }

      if (this.getQueryString('code')) {
        this.code = this.getQueryString('code');
      }

      //支付上报初始化
      this.payment_log = new PaymentLog();
      this.payment_log.init({
        env: this.env,
        app_id: this.env == 'production' ? 'web_vip_mall.global.prod' : 'web_vip_mall.global.sandbox',
        fornt_name: 'web-vip-mall'
      })

      this.getGameInfo();

      this.$rum.setShareProperties({
        gameid: this.gameid
      })

      this.getPackageInfo(() => {
        if (this.code && this.code != "") {
          upcustomurl({
            code: this.code
          }).then(res => {
            console.log('opensuccess')
          })
        }

      });

    },
    beforeDestroy() {
      //先删防止重复监听
      document.removeEventListener("visibilitychange", this.visibilitychangefn);
    },
    methods: {
      ...mapActions([
        'setShowLoading'
      ]),
      closeAppLoginModal() {
        this.apploginis=false;
        this.apploginsty = 1;
      },
      openlogin(){
        if(this.appenv == true){
          this.apploginsty = 2;
        }
        this.apploginis=true;
      },
      appenvtest(){
        //在facebook或isMessenger打开
        const isMessenger = /FBAV\//i.test(navigator.userAgent);
        //dingding
         const isdingding = /DingTalk/i.test(navigator.userAgent);
        //Snapchat、Instagram、line、
        const isSnapchat = /Snapchat/i.test(navigator.userAgent);
        const isInstagram = /Instagram/i.test(navigator.userAgent);
        const isLINE = /Line/i.test(navigator.userAgent);

        if (isMessenger || isdingding || isSnapchat || isInstagram || isLINE) {
          this.appenv = true;
        } else {
        	this.appenv = false;
        }
      },
      jumpGame() {
        if(this.appenv == true){
          this.opennotice(this.$t('game.appnotice'),'notice')
        }else{

          //弹一个弹框用来防止监听失效或者不支持监听的浏览器
          setTimeout(()=>{
            console.log('弹框了')
            this.opennotice(this.$t('game.reloadmsg'), this.checksession,'',this.$t('game.reload'));
          },2000)

          //说明点击跳转了
          this.sessionclickis = true;

          if (window.self !== window.top) {
              console.log("页面是在 iframe 中打开的");
              window.open(this.game_login_info.login_url);
          } else {
              console.log("页面不是在 iframe 中打开的");
              window.location.href = this.game_login_info.login_url;
          }

        }
      },
      //获取session和url
      async getsession(){
        const sessionKey = this.gameid + 'vip_mall_code'
        var vip_mall_code = localStorage.getItem(sessionKey);
        var vip_mall_url = localStorage.getItem(sessionKey + "_url");
        if(vip_mall_code && vip_mall_code!=''){
          //说明有session 同时还没有登录，使用缓存当中的
          this.game_login_info = {
            session :vip_mall_code,
            login_url :vip_mall_url
          }

          //尝试去更新session
          this.checksession('nomsg');
        }else{
           //说明没有session 去请求
           try {
             const res = await getSession({
               game_id: this.gameid
             })
             console.log('getSession', res);
             if (res.data.code === 1) {
               this.game_login_info = res.data.data
               window.localStorage.setItem(sessionKey,this.game_login_info.session);
               window.localStorage.setItem(sessionKey+"_url", this.game_login_info.login_url);
             }
           } catch (error) {
             console.log(error);
           }
        }

        //先删防止重复监听
        document.removeEventListener("visibilitychange", this.visibilitychangefn);
        // 检测页面可见性的改变
        document.addEventListener("visibilitychange",this.visibilitychangefn);

      },
      visibilitychangefn(){
        if (document.hidden) {
          // 页面被隐藏时的操作
          console.log("页面被隐藏");
        } else {
          // alert('show')
          console.log("页面显示了");

          //关闭掉确认弹框
          if(this.$refs.notice){
            this.$refs.notice.close();
          }


          //校验登录情况
          this.checksession()
        }
      },
      //获取登录信息
      async checksession(nomsg){

        //成功checksession后，请除session的local缓存
        //console.log("id");
        this.checkid('leftcount', null, this.game_login_info.session,nomsg);
        //console.log(this.game_login_info.session);

      },
      getfrontcountry(){
        const browserLang = (navigator.appName=='Netscape' ? navigator.language : navigator.userLanguage).toLowerCase()
        var country = 'United States'
        var countrymap = {
          'zh-hk':'Hong Kong',
          'ja':'Japan',
          'ko':'Korea',
          'en-sg':'Singapore',
          'ar-sa':'Saudi Arabia',
          'ar-iq':'Iraq',
          'zh-tw':'Taiwan',
          'th':'Thailand',
          'ar-ae':'United Emirates',
          'en-za':'South Africa',
          'de':'Germany',
          'de-de':'Germany',
          'pt':'Portugal',
          'pt-br':'Portugal',
          'pt-pt':'Portugal',
          'ru':'Russia',
          'es':'Spain',
          'de-ch':'Switzerland',
          'fr-ch':'Switzerland',
          'de-ch':'it-ch',
          'en-gb':'United Kingdom',
          'en-gb-oxendict':'United Kingdom',
          'en-au':'Australia',
        }
        return countrymap[browserLang]?countrymap[browserLang]: country;
      },
      logout(){
        this.opennotice(this.$t('game.changeaccount'),()=>{},()=>{
          this.editis = false;
          localStorage.removeItem("game_user_id_"+this.gameid);
          localStorage.removeItem('vip_country_'+this.gameid+'_'+this.gameinfo.id);

          //清空信息
          this.$set(this.gameinfo, 'id', '');
          this.$set(this.gameinfo, 'icon', '');
          this.$set(this.gameinfo, 'name', '');
          this.$set(this.gameinfo, 'role_id', '');
          this.$set(this.gameinfo, 'extra_info', {});
          this.$set(this.gameinfo, 'player_whitelist_status', false);
          this.player_whitelist_status = false;

          //如果是移动端同时后台开启了app登录即app_login_status为1时
          if(this.loginsty == 1){
             this.getsession();
          }

          //退出更新一下列表
          this.getPackageInfo();
        },this.$t('game.orderCancel'),this.$t('game.confirm'))
      },
      opennotice(msg,fn,cancel,oktext,canceltext,title){
        this.noticeinfo = {
          content:msg,
          success:fn,
          cancel:cancel,
          oktext:oktext,
          canceltext:canceltext,
          title:title
        }
        this.$refs.notice.open();
      },
      getotherClass(item) {
        var cls = 'diyothercontent ' + ('diyother' + item.length);
        return cls;
      },
      paychange(item) {
        this.paysty = item;
        //判断当前商品是否在当前支付方式中
        if (this.gateway_package_ids[this.gatewayMap[this.paysty]]) {
          this.idarr = this.gateway_package_ids[this.gatewayMap[this.paysty]];
          if (!this.idarr.includes(this.packageid)) {
            this.clearid();
          }
        }
      },
      shownopackage() {
        var showis = false;
        // console.log('this.gateway_package_ids[this.gatewayMap[this.paysty]]')
        // console.log(this.gateway_package_ids[this.gatewayMap[this.paysty]])
        if (this.list.length !== 0 && (!(this.gateway_package_ids && this.gateway_package_ids[this.gatewayMap[this.paysty]]) || this
            .gateway_package_ids[this.gatewayMap[this.paysty]].length == 0)) {
          showis = true;
        }
        return showis;
      },
      showid(id) {
        // console.log('this.paysty');
        // console.log(this.gateway_package_ids);
        if (this.gateway_package_ids && this.gateway_package_ids[this.gatewayMap[this.paysty]]) {
          this.idarr = this.gateway_package_ids[this.gatewayMap[this.paysty]];
          //console.log(this.idarr)
          return this.idarr.includes(id);
        } else {
          return false
        }
      },
      adyencheckagain() {
        if (this.getQueryString('redirectResult')) {
          this.redirectResult = this.getQueryString('redirectResult');
          var obj = {}
          obj.details = {
            "redirectResult": decodeURI(this.redirectResult)
          }

          this.payment_log.set_properties({
            cg_request_id: this.provider_order_id,
            user: this.gameinfo.id,
            gateway: 'adyen',
            appid: this.payment_appid + ''
          });
          this.payment_log.report('web_payment_check_success');
          this.payment_log.report('web_payment_checkAgain_start');

          this.detailresult({
            "provider_order_id": this.provider_order_id,
            "details": JSON.stringify(obj),
          })
        }
      },
      // 获取游戏信息
      async getGameInfo() {
        try {
          const res = await gameInfo({
            game_id: this.gameid
          })
          console.log('getGameInfo', res);
          const info = res.data.data;
          this.quesarrr = info.guide_pic_list;
          this.game_whitelist_status = info.game_whitelist_status;
          this.apology_pic = info.apology_pic;;
          this.gameBanner = info.icon;
          this.payment_appid = info.appid ? info.appid : '';
          this.is_paypal_advance = info.is_paypal_advance
          //判断登录流程
          if(this.detectDeviceType() == 'Mobile'){

            //如果是移动端同时后台开启了app登录即app_login_status为1时
            if(info.app_login_status == 1){
              this.loginsty = 1;
            }else{
              this.loginsty = 2;
            }

          }else{
            this.loginsty = 2;
          }

          //尝试登录
          if (this.gameinfo.id != '') {
            this.checkid();
          }else{
            //说明没有登录id，获取session和跳转url
            console.log(this.loginsty+'---------')
            if(this.loginsty == 1){
              //说明开启了登录
              this.getsession()
            }
          }

        } catch (error) {
          console.log(error);
        }
        this.adyencheckagain();
      },
      detectDeviceType() {
        var dt =  /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent) ? 'Mobile' : 'PC';


        //判断pad
        if(window.innerWidth < 1024 ){
          dt = 'Mobile';
        }

        return dt;
      },
      soldout() {
        return false;
      },
      //获取凭证
      getinvoice() {
        this.maskstyle = '';
        this.invoiceis = true;
      },
      setcount(count) {
        if (count > 1000000000000000000) {
          count = outzero((count / 1000000000000000000).toPrecision(3)) + 'bb'
        } else if (count > 1000000000000000) {
          count = outzero((count / 1000000000000000).toPrecision(3)) + 'aa'
        } else if (count > 1000000000000) {
          count = outzero((count / 1000000000000).toPrecision(3)) + 't'
        } else if (count > 1000000000) {
          count = outzero((count / 1000000000).toPrecision(3)) + 'b'
        } else if (count > 1000000) {
          count = outzero((count / 1000000).toPrecision(3)) + 'm'
        } else if (count > 10000) {
          count = outzero((count / 1000).toPrecision(3)) + 'k'
        }

        function outzero(val) {

          var arr = val.toString().split('');
          var l = arr.length;
          if (arr[l - 1] == 0) {
            arr = arr.slice(0, l - 1)
          }
          if (arr[arr.length - 1] == '.') {
            arr = arr.slice(0, arr.length - 1)
          }
          return arr.join('')
        }
        return count;
      },
      updateProviderOrderId(id) {
        this.provider_order_id = id
      },
      sendInvoice() {
        //console.log('send')
        if (this.provider_order_id == '') {
          this.provider_order_id = sessionStorage.getItem('provider_order_id')
        }
        var obj = {

          "game_id": this.gameid,
          "fpid": this.fpid,
          "email": this.mail_data.mail,
          "is_remember": this.mail_data.is_remember + '',
          "is_send_information": this.mail_data.is_send_information + "",
          "provider_order_id": this.provider_order_id,
          // "uuid": this.orderinfo.OrderID,
          // "transaction_id": this.orderinfo.TransactionID,
          // "transaction_date": this.orderinfo.Transactiondate ,
          // "price": this.moneyunit + this.packagedict['package'+this.packageid].package.final_amount,
          // "package_id": this.packageid
        }

        //console.log(obj)
        getinvoice(obj).then(res => {
          if (res.data.code == 1) {
            this.invoiceis = false;
            if (this.mail_data.is_remember == false) {
              this.$set(this.mail_data, 'mail', '');
            }
            this.alert(this.$t('game.sendSuccess'))
          } else {
            this.alert(res.data.msg)
          }
        }).catch(err => {
          this.alert('request error')
        })


      },
      alert(msg) {
        this.$store.commit('SET_ALERT', {
          type: 'error',
          content: msg,
          showis: true
        })
      },
      //去确认订单
      gotodetail() {
        var accept = localStorage.getItem('acceptis');
        if (!(accept && (accept + '') == 'true')) {
          return this.$store.commit('SET_ACCEPT', true);
        }

        if (this.packageid == '') {
          return this.pakcageis = false;
        } else {
          this.pakcageis = true;
        }

        this.setShowLoading(true)
        if (this.editis == false) {
          var checkis = true;
          this.checkid('leftcount',() => {
            this.setShowLoading(false)
            if (this.editis == false) {
              //this.alert('ID not found. Please try again.');
              checkis = false;
            }
            if (checkis) {
              if (this.editis == true && this.packageid != '') {
                this.orderconfirm = true;
              }
            }
          })
        } else {
          if (this.editis == true && this.packageid != '') {
            this.packagereset(() => {
              this.setShowLoading(false)
              if (this.packageid != '') {
                this.orderconfirm = true;
              }
            })
          }
        }

      },
      //支付
      pay() {
        if (this.editis == true && this.packageid != '') {
          var obj = {
            game_id: this.gameid,
            uid: this.fpid,
            product_id: this.packagedict['package' + this.packageid].package.package_id,
            pack: this.packageid,
            list_id: this.list_id,
            owner: this.owner,
            amount: this.packagedict['package' + this.packageid].package.final_amount,
            currency: this.conutry.money,
            currency_label: this.moneyunit,
            // gateway和os, 国内支付宝和微信预订单接口特有参数
            gateway: this.gatewayMap[this.paysty],
            os: window.navigator.userAgent.toLocaleLowerCase().indexOf('android') > -1 ? 'android' : 'iOS',
            package_type: this.packagedict['package' + this.packageid].package_type ? this.packagedict['package' +
              this.packageid].package_type : 1,

          }
          if (this.gameinfo.extra_info && this.gameinfo.extra_info.key) {
            obj.user_extra_key = this.gameinfo.extra_info.key;
            obj.user_extra_value = this.gameinfo.extra_info.value;
          }
          if (obj.package_type == 2) {
            obj.package_info = this.difpackageinfo['vip' + this.packagedict['package' + this.packageid].id];
          } else {
            obj.package_info = {};
          }
          obj.package_info = JSON.stringify(obj.package_info);

          var mountobj = {}
          mountobj.value = Math.round(this.packagedict['package' + this.packageid].package.final_amount * 100);
          mountobj.currency = this.conutry.money;
          this.$set(this, 'mount', mountobj);

          //清空订单号
          this.$set(this, 'orderinfo', {
            OrderID: '',
            TransactionID: '',
            Transactiondate: '',
            real_amount: ''
          });

          //
          this.payment_log.clear_properties()
          this.payment_log.set_properties({
            user: this.fpid,
            currency_code: this.conutry.money,
            amount: obj.amount,
            product_id: obj.product_id,
            gateway: this.paysty,
            appid: this.payment_appid + ''
          })
          this.payment_log.set_clickid();

          obj.click_id = this.payment_log.logdata.click_id;
          this.$set(this, 'payinfo', obj);

          //paystart
          this.orderconfirm = false;
          console.log('----ajax-')
          console.log(this.difpackageinfo['vip' + this.packagedict['package' + this.packageid].id])
          this.shwoPayComponent = true;

          this.payment_log.report('web_payment_buy_start');
        }
      },
      //检测detail
      detailresult(obj) {
        // var obj = {
        //     // "game_id": this.payinfo.game_id,
        //     "details": JSON.stringify(state.data),
        //     "provider_order_id": this.provider_order_id,
        // }
        adyen_payments_details(obj).then(response => {
          if (response.data.code == 1) {
            this.successpay(response.data.data);
            this.payment_log.set_properties({
              transaction_id: response.data.data.transaction_id ? response.data.data.transaction_id : ''
            });
            this.payment_log.report('web_payment_checkAgain_success');
          } else {
            this.failpay(response.data);
            this.payment_log.report('web_payment_checkAgain_fail', {
              code: 3,
              msg: response.data.msg ? response.data.msg : 'adyen_payments_details failed'
            });
          }
        }).catch(error => {
          this.failpay(error);
          this.payment_log.report('web_payment_checkAgain_error', {
            code: 2,
            msg: error
          });
          throw Error(error);
        });
      },
      //子组件支付成功
      successpay(data) {
        //console.log(data);
        if (data.transaction_id) {
          this.orderinfo.TransactionID = data.transaction_id;
        }
        if (data.uuid) {
          this.orderinfo.OrderID = data.uuid;
        }
        if (data.date) {
          this.orderinfo.Transactiondate = data.date;
        }

        if (data.real_amount) {
          this.orderinfo.real_amount = data.real_amount;
        } else {
          this.orderinfo.real_amount = this.gameinfo.money;
        }

        this.shwoPayComponent = false
        this.maskstyle = 'success';
        this.$rum.report('pay_vip_sucess', data, 1)
        //更新礼包
        this.packagereset();
      },
      //支付失败
      failpay(data) {
        this.shwoPayComponent = false;
        if (data.data) {
          if (data.data.transaction_id) {
            this.orderinfo.TransactionID = data.data.transaction_id;
          }
          if (data.data.uuid) {
            this.orderinfo.OrderID = data.data.uuid;
          }
          if (data.data.date) {
            this.orderinfo.Transactiondate = data.data.date;
          }

          if (data.data.real_amount) {
            this.orderinfo.real_amount = data.data.real_amount;
          } else {
            this.orderinfo.real_amount = this.gameinfo.money;
          }

          if (data.code == 15012) {
            this.maskstyle = 'deliveryfail'
          } else {
            this.maskstyle = 'payfail'
          }
        } else {
          this.orderinfo.real_amount = this.gameinfo.money;
          this.maskstyle = 'payfail'
        }
        this.$rum.report('pay_vip_fail', data, 1)
      },
      faipaypallpay(sty) {
        this.shwoPayComponent = false;
        this.orderinfo.real_amount = this.gameinfo.money;
        this.maskstyle = sty;
      },
      //子组件取消支付
      cancelpay() {
        this.shwoPayComponent = false
        this.orderconfirm = true;
      },
      selpackage(item) {

        //判断当前商品是否在当前支付方式中
        if (this.gateway_package_ids[this.gatewayMap[this.paysty]]) {
          this.idarr = this.gateway_package_ids[this.gatewayMap[this.paysty]];
          if (this.idarr.includes(item.id)) {
            this.packageid = item.id;
            this.gameinfo.money = item.package.final_amount;
            this.gameinfo.packagename = item.package.package_en_name;
          } else {
            this.clearid();
          }
        }

        //console.log(item.id)
      },
      clearid() {
        this.packageid = '';
        this.gameinfo.money = 0;
        this.gameinfo.packagename = '';
      },
      openother(list, now, sty, id, index) {
        if (list.length && list.length > 1) {
          this.otherlist = list;
          this.nowselect = now;
          this.otherselectsty = {
            style: sty,
            id: id,
            index: index
          };
          this.otherselectis = true;
          document.documentElement.style.overflowY = 'hidden';

        }
        return false;
      },
      otherconfirm(item) {
        if (this.otherselectsty.style == 'other') {
          this.difpackageinfo['vip' + this.otherselectsty.id].other_content[this.otherselectsty.index] = item;
        } else {
          this.difpackageinfo['vip' + this.otherselectsty.id].main_content = item;
        }
        document.documentElement.style.overflowY = 'auto';
        this.otherselectis = false;
      },
      //diy礼包初始化
      diypackageinit(list) {
        this.difpackageinfo = {};
        var difpackageinfo = {}
        list.forEach((el) => {
          if (el.package_type && el.package_type == 2) {
            //difpackageinfo
            console.log('------difpackageinfo')
            console.log(el)

            var obj = {
              main_content: el.package.diy_main_content[0],
              other_content: []
            }
            for (let k in el.package.diy_other_content) {
              if (el.package.diy_other_content[k].length && el.package.diy_other_content[k].length > 0) {
                obj.other_content.push(el.package.diy_other_content[k][0])
              }
            }
            difpackageinfo['vip' + el.id] = obj;
          }
        })
        this.$set(this, 'difpackageinfo', difpackageinfo);
        console.log(this.difpackageinfo)


      },
      //礼包更新接口
      packagereset(fn) {
        packagesinfo({
          fpid: this.fpid,
          game_id: this.gameid,
          list_id: this.list_id,
          currency: this.conutry.money
        }).then(res => {
          console.log('packagereset')
          console.log(res)
          if (res.data.code == 1) {
            if (res.data.data) {
              var obj = {}
              res.data.data.package_info.forEach(item => {
                obj['a' + item.id] = item.left_count;
              });
              this.$set(this, 'gateway_package_ids', res.data.data.gateway_package_ids);
              //console.log(this.gateway_package_ids);
              this.list.forEach((el, index) => {
                if (el.id == this.packageid && (obj['a' + el.id] + '') == '0') {
                  this.clearid()
                }

                this.$set(this.list[index].package, 'limit_pay_count', obj['a' + el.id]);
              })
              //this.diypackageinit(this.list);
              this.list = this.resetlist(this.list)
            }
            if (fn) {
              fn();
            }
          } else {
            //console.log('礼包已经购买成功')
          }
        })
      },
      updateleftcount(sucess){
        this.setShowLoading(true);
        var obj = {
          'game_id': this.gameid,
          'currency': this.conutry.money,
          'fpid': this.fpid,
        }
        if (this.list_id != '' && this.list_id + '' != 'undefined') {
          obj.list_id = this.list_id;
        }
        //this.packagedict = {};
        packagesinfo(obj).then(res => {
          console.log('updateleftcount')
          if (res.data.code == 1) {
            this.$set(this, 'gateway_package_ids', res.data.data.gateway_package_ids);

            //更新 left_count
            if (res.data.data.package_info) {
              var obj = {}
              res.data.data.package_info.forEach(item => {
                obj['a' + item.id] = item.left_count;
              })
              this.list.forEach((el, index) => {
                if (el.id == this.packageid && (obj['a' + el.id] + '') == '0') {
                  this.clearid()
                }
                this.$set(this.list[index].package, 'limit_pay_count', obj['a' + el.id]);
              });
              this.list = this.resetlist(this.list);
            }

            if (this.packageid != '' && this.gameinfo.packagename == '' && this.packagedict['package' + this
                .packageid]) {
              console.log('------initno_package------')
              this.selpackage(this.packagedict['package' + this.packageid]);
            }

            if (sucess && typeof sucess === "function") {
              sucess();
            }

          }
          this.setShowLoading(false);
        })
      },
      async checkid(sty = '',sucess = null, session,nomsg) {
        if (this.gameinfo.id !== '' || session) {

          if(this.checkis == true){
            return false;
          }else{
            this.checkis = true;
          }

          this.$set(this.gameinfo, 'icon', '');
          this.$set(this.gameinfo, 'name', '');
          this.$set(this.gameinfo, 'role_id', '');
          this.$set(this.gameinfo, 'extra_info', {});
          this.$set(this.gameinfo, 'player_whitelist_status', false);
          this.player_whitelist_status = false;

          try {
            let res = null
            if (session) {
              res = await getUserInfoBySession({
                session,
                game_id: this.gameid,
              })
            } else {
              res = await checkfpid({
                fpid: this.gameinfo.id,
                game_id: this.gameid,
              })
            }

            console.log('登录结果----')
            console.log(res)
            if (res.data.code == 1) {

              var dat = res.data.data.user_data[0];
              // 清除session
              localStorage.removeItem(this.gameid + 'vip_mall_code');
              localStorage.removeItem(this.gameid + 'vip_mall_code_url');



              //登录成功后去掉监听
              document.removeEventListener("visibilitychange", this.visibilitychangefn);

              //缓存当前id
              localStorage.setItem("game_user_id_"+this.gameid, dat.user_id)
              this.$set(this.gameinfo, 'id', dat.user_id);
              this.$set(this.gameinfo, 'icon', dat.icon);
              this.$set(this.gameinfo, 'name', dat.nickname);
              this.$set(this.gameinfo, 'role_id', dat.role_id);
              this.$set(this.gameinfo, 'extra_info', dat.extra_info);
              this.$set(this, 'fpid', dat.fpid);
              this.player_whitelist_status = dat.player_whitelist_status;

              //获取账单信息
              this.$set(this, 'mail_data', res.data.data.mail_data);
              this.checktext = ''
              this.editis = true;

              // 关闭登陆弹窗
             this.closeAppLoginModal();

              //判断国家
              var vip_country = localStorage.getItem('vip_country_'+this.gameid+'_'+this.gameinfo.id);
              if(vip_country){
                //说明是有缓存国家直接用本地不用调整
              }else{
                //没有缓存说明是第一次登录判断是否弹框

                var nowfrontconutry = this.conutry.content;
                console.log('nowfrontconutry', nowfrontconutry, dat.country);

                //后端国家有可能不在18个国家里。
                var servercountry = 'United States';
                conutryarr.forEach(item => {
                  if (item.content == dat.country) {
                    servercountry = item.content;
                  }
                })

                if(servercountry && nowfrontconutry != servercountry){
                  //前后端返回国家不一致就弹框是否切换国家
                  this.opennotice(`Your preferred country is ${servercountry}. Would you like to switch country and currency?`,()=>{
                    conutryarr.forEach(item => {
                      if (item.content == servercountry) {
                        this.$store.commit('SET_COUNTRY', item);
                      }
                    })
                    localStorage.setItem('vip_country_'+this.gameid+'_'+this.gameinfo.id, servercountry)
                  },()=>{
                    //取消
                    localStorage.setItem('vip_country_'+this.gameid+'_'+this.gameinfo.id,nowfrontconutry)
                  })
                }else{
                  //一致则缓存当前国家
                  localStorage.setItem('vip_country_'+this.gameid+'_'+this.gameinfo.id,nowfrontconutry)
                }
              }

              this.$rum.setShareProperties({
                userId: dat.role_id,
                gameid: this.gameid
              })

              this.updateleftcount(sucess);

            } else {
              //失败就返回
              if (typeof sucess === "function") {
                sucess();
              }

              //判断如果是点击按钮跳转的返回后 失败了则提示
              if(this.sessionclickis == true){
                this.opennotice(this.$t('game.logintip'), 'notice','','','',this.$t('game.loginfail'));
                this.sessionclickis = false;
              }

              //说明第一次进来重试session 不用提醒
              if(nomsg && nomsg=='nomsg'){

              }else{
                if (session) {
                   //不提示了
                }else{
                  this.checktext = res.data.msg;
                }
              }
            }

            this.checkis = false;
          } catch (error) {
            console.log(error)
          }
        } else {
          if (typeof sucess === "function") {
            sucess();
            this.checktext = this.$t('game.id404');
          }
        }

      },
      handleCheckedCitiesChange(value) {
        var arr = ['bonusoff', 'bonus', 'total', 'off'];
        var val = '';
        arr.forEach((item, index) => {
          if (value.indexOf(item) > -1) {
            val = item;
          }
        })
        this.disabledval = val;
      },
      //更新礼包顺序
      resetlist(list) {
        var newlist = [];
        var oldlist = [];
        list.forEach(item => {
          if (item.package.limit_pay_count < 0) {
            item.package.limit_pay_count = 0
          };

          if (item.package.limit_pay_count + '' != 'null' && item.package.limit_pay_count + '' == '0') {
            oldlist.push(item);
          } else {
            newlist.push(item);
          }
        })
        return newlist.concat(oldlist)
      },
      getPackageInfo(fn) {
        var obj = {
          'game_id': this.gameid,
          'currency': this.conutry.money
        }
        if (this.list_id != '' && this.list_id + '' != 'undefined') {
          obj.list_id = this.list_id;
        }
        this.packagedict = {};
        gamePackagesInfo(obj).then(res => {
          if (res.data.code == 1) {
            console.log('packagesinfo');
            console.log(res);
            let config = JSON.parse(res.data.data.config);
            console.log(config)
            this.checkList = config.checkList;

            //初始化diy
            this.diypackageinit(config.list);
            this.list = this.resetlist(config.list);
            this.list_id = res.data.data.id;
            this.list.forEach((item, index) => {
              this.packagedict['package' + item.id] = item;
            });
            this.gateway_package_ids = res.data.data.gateway_package_ids;
            if (this.list.length > 0) {
              this.moneyunit = this.list[0].package.currency_label + ' ';
            } else {
              this.nopackis = true;
            }
            if (res.data.data.paypal_client_id) {
              this.paypal_client_id = res.data.data.paypal_client_id;
            }

            this.advanceCardSupport = res.data.data.is_advance_card_support_currency;

            // 43：wechat, 14: alipay, 0: paypal, 75: adyen
            const payWayMap = {
              43: '微信',
              14: '支付宝',
              0: 'paypal',
              75: 'adyen',
            }
            const arr = []
            res.data.data.support_gateways.forEach(res => arr.push(payWayMap[res]));
            this.payway = arr;
            this.paysty = this.paysty + '' != 'null' ? this.paysty : arr[0];
            this.handleCheckedCitiesChange(this.checkList)
            if (this.packageid != '' && this.packagedict['package' + this.packageid]) {
              this.selpackage(this.packagedict['package' + this.packageid]);
            }
            if (fn) {
              fn();
            }
          } else {
            this.nopackis = true;
          }
        })
      },
      getQueryString(name) {
        return this.$route.query[name] || null;
      },
      priceinit(price) {

        if (price != null && price.indexOf('.') > -1) {
          price = (price * 1).toFixed(2)
        }
        if (price > 10000) {
          price = Math.ceil(price / 100) * 100;
        } else if (price > 1000) {
          price = Math.ceil(price);
        }

        return price;
      }

    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/game.vue